export default __webpack_public_path__ + "static/seamless-sales-983b9925aca12d13cfaaa6deb7f72633.webp";